import { useTheme } from '@mui/material'
import { FlexBoxProps, FlexRow } from '@xylabs/sdk-react'
import { Quadkey } from '@xyo-network/sdk-xyoworld-js'
import React from 'react'

import ComponentSize from '../../ComponentSize'
import Children from './Children'
import Parent from './Parent'

interface FamilyProps extends FlexBoxProps {
  hideQuadkey?: boolean
  hideTitles?: boolean
  hideValue?: boolean
  quadkey?: Quadkey
  size?: ComponentSize
  spacing?: number
}

const Family: React.FC<FamilyProps> = ({ flexDirection, hideValue, hideQuadkey, hideTitles, quadkey, size = 'medium', spacing = 1, ...props }) => {
  const theme = useTheme()

  return (
    <FlexRow paper alignItems="stretch" flexDirection={flexDirection} {...props}>
      <Parent
        quadkey={quadkey}
        hideQuadkey={hideQuadkey}
        hideValue={hideValue}
        hideTitle={hideTitles}
        size={size}
        spacing={spacing}
        borderBottom={flexDirection === 'column' ? `solid 1px ${theme.palette.divider}` : undefined}
        borderRight={flexDirection !== 'column' ? `solid 1px ${theme.palette.divider}` : undefined}
        display="flex"
      />
      <Children hideTitle={hideTitles} hideQuadkey={hideQuadkey} hideValue={hideValue} quadkey={quadkey} size={size} spacing={spacing} flexGrow={1} />
    </FlexRow>
  )
}

export default Family
